import { createStyles, Icon, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Routes } from '../routes';

import PrimaryTheme from '../Themes/Primary';
import Lists from './List';
import "./navigation.scss";
export default function Navigation() {
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();



  const logout = () => {
    dispatch({
      type: "LOADING",
      payload: true
    })
    dispatch({
      type: "USER",
      payload: {}
    })

    dispatch({
      type: "IS_LOGGED_IN",
      payload: {}
    })
    dispatch({
      type: "AUTH_TOKEN",
      payload: {}
    });

    sessionStorage.clear();

    setTimeout(() => {
      dispatch({
        type: "LOADING",
        payload: false
      })
      window.location.pathname = '/';
    }, 500);

  }

  return (
    <div style={{
      overflowY: "auto",
      height: '100vh',
      backgroundColor: 'white',
      paddingTop: 10,
    }} className="navigation__cover">

      <div className="col-md-12 p-2 mt-3 mb-3 big-screen-logo">
        <img
          className={classes.large + ' mr-auto ml-auto pointer'}
          alt={`Bankly`}
          src={'/logo-blue.png'} />
      </div>

      {Routes.map((route, index) => (
        <React.Fragment key={index}>
          {route.forNav && <Lists
            button={true}
            icon={route.icon}
            path={route.path}
            color={location.pathname === route.path && PrimaryTheme.primary}
            name={route.name}
            className={location.pathname === route.path ? 'Nav-Active' : null} />}
        </React.Fragment>
      ))}
 <button onClick={logout} className="btn btn-default pl-3 pr-3" style={{
          color: PrimaryTheme.danger
        }}>
          <div className="row m-0 justify-content-center">
            <Icon>exit_to_app</Icon>
            <span style={{
              fontFamily: PrimaryTheme.fonts?.RegularFont,
              // fontSize: PrimaryTheme.fontSizes?.body,
              marginLeft: 5
            }}>Logout</span>
          </div>
        </button>
     
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    large: {
      width: theme.spacing(17),
      // height: theme.spacing(15),
    },
  }),
);

